(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["featured-product"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('product-modal')) {
    customElements.define('product-modal', class ProductModal extends ModalDialog {
      constructor() {
        super();
      }

      hide() {
        super.hide();
        window.pauseAllMedia();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }

      showActiveMedia() {
        this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
            element.classList.remove('active');
          }
        )
        const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
        activeMedia.classList.add('active');
        activeMedia.scrollIntoView();

        const container = this.querySelector('[role="document"]');
        container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

        if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMedia.querySelector('template')?.content?.querySelector('.js-youtube'))
          activeMedia.loadContent();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["flexible-hero"] && !Shopify.designMode) return;
  try {
    
  if (!window.flexibleHeroVideoInitialized) {
    window.flexibleHeroVideoInitialized = true;
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    const desktopViewport = window.matchMedia('(min-width: 750px)');
    const observedVideos = new WeakSet();
    const nearbyVideos = new WeakSet();

    const videoMatchesViewport = (video) => {
      if (video.classList.contains('flexible-hero__media-item--desktop-only')) {
        return desktopViewport.matches;
      }

      if (video.classList.contains('flexible-hero__media-item--mobile-only')) {
        return !desktopViewport.matches;
      }

      return true;
    };

    const syncVideo = (video) => {
      video.muted = true;
      video.defaultMuted = true;

      const shouldPlay = nearbyVideos.has(video) && !reducedMotion.matches && videoMatchesViewport(video);
      video.autoplay = shouldPlay;
      delete video.dataset.autoplayBlocked;

      if (!shouldPlay) {
        video.pause();
        return;
      }

      const playPromise = video.play();
      if (playPromise) {
        playPromise.catch(() => {
          video.dataset.autoplayBlocked = 'true';
        });
      }
    };

    const videoObserver =
      typeof window.IntersectionObserver === 'function'
        ? new window.IntersectionObserver(
            (entries) => {
              entries.forEach((entry) => {
                if (!observedVideos.has(entry.target) || entry.target.isConnected === false) {
                  videoObserver.unobserve(entry.target);
                  observedVideos.delete(entry.target);
                  nearbyVideos.delete(entry.target);
                  entry.target.autoplay = false;
                  entry.target.pause();
                  return;
                }

                if (entry.isIntersecting) {
                  nearbyVideos.add(entry.target);
                } else {
                  nearbyVideos.delete(entry.target);
                }
                syncVideo(entry.target);
              });
            },
            { rootMargin: '200px 0px' }
          )
        : null;

    const initializeVideos = (root) => {
      root.querySelectorAll('[data-flexible-hero-video]').forEach((video) => {
        if (videoObserver && !observedVideos.has(video)) {
          observedVideos.add(video);
          videoObserver.observe(video);
        } else if (!videoObserver) {
          nearbyVideos.add(video);
        }
        syncVideo(video);
      });
    };

    const stopVideos = (root) => {
      root.querySelectorAll('[data-flexible-hero-video]').forEach((video) => {
        if (videoObserver) videoObserver.unobserve(video);
        observedVideos.delete(video);
        nearbyVideos.delete(video);
        video.autoplay = false;
        video.pause();
      });
    };

    document.addEventListener('shopify:section:load', (event) => {
      if (event.target instanceof Element) initializeVideos(event.target);
    });
    document.addEventListener('shopify:section:unload', (event) => {
      if (event.target instanceof Element) stopVideos(event.target);
    });

    const handlePlaybackPreferenceChange = () => {
      document.querySelectorAll('[data-flexible-hero-video]').forEach(syncVideo);
    };
    const handleViewportChange = () => {
      document.querySelectorAll('[data-flexible-hero-video]').forEach((video) => {
        video.autoplay = false;
        video.pause();
        video.load();
        syncVideo(video);
      });
    };

    if (reducedMotion.addEventListener) {
      reducedMotion.addEventListener('change', handlePlaybackPreferenceChange);
      desktopViewport.addEventListener('change', handleViewportChange);
    } else {
      reducedMotion.addListener(handlePlaybackPreferenceChange);
      desktopViewport.addListener(handleViewportChange);
    }

    initializeVideos(document);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('ul'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      this.elements.input.value = event.currentTarget.dataset.value;
      this.querySelector('form')?.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.getElementById('shopify-section-header');
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.preventReveal) {
        window.clearTimeout(this.isScrolling);

        this.isScrolling = setTimeout(() => {
          this.preventReveal = false;
        }, 66);

        requestAnimationFrame(this.hide.bind(this));
      } else {
        if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
          requestAnimationFrame(this.hide.bind(this));
        } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
          requestAnimationFrame(this.reveal.bind(this));
        } else if (scrollTop <= this.headerBounds.top) {
          requestAnimationFrame(this.reset.bind(this));
        }
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-footer"]) return;
  try {
    
  class CartNote extends HTMLElement {
    constructor() {
      super();

	  const noteBoxContainer = document.getElementById('cart__note');
      const noteBox = document.getElementById('Cart-note');
      if(noteBox.value.length > 0) {
        noteBoxContainer.style.display = 'block';
      }

	  const bodytest = fetch(`${routes.cart_url}`);

      this.addEventListener('input', debounce((event) => {
        const body = JSON.stringify({ note: event.target.value });
        fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }});
      }))
    }
  }

  customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-minimal"]) return;
  try {
    
  class ProductModal extends ModalDialog {
    constructor() {
      super();
    }

    hide() {
      super.hide();
      window.pauseAllMedia();
    }

    show(opener) {
      super.show(opener);
      this.showActiveMedia();
    }

    showActiveMedia() {
      this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
          element.classList.remove('active');
        }
      )
      const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
      activeMedia.classList.add('active');
      activeMedia.scrollIntoView();

      const container = this.querySelector('[role="document"]');
      container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

      if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMedia.querySelector('template')?.content?.querySelector('.js-youtube'))
        activeMedia.loadContent();
    }
  }

  customElements.define('product-modal', ProductModal);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-new"]) return;
  try {
    
  class ProductModal extends ModalDialog {
    constructor() {
      super();
    }

    hide() {
      super.hide();
      window.pauseAllMedia();
    }

    show(opener) {
      super.show(opener);
      this.showActiveMedia();
    }

    showActiveMedia() {
      this.querySelectorAll(
        `[data-media-id]:not([data-media-id="${this.openedBy.getAttribute('data-media-id')}"])`
      ).forEach((element) => {
        element.classList.remove('active');
      });
      const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);
      activeMedia.classList.add('active');
      activeMedia.scrollIntoView();

      const container = this.querySelector('[role="document"]');
      container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

      if (
        activeMedia.nodeName == 'DEFERRED-MEDIA' &&
        activeMedia.querySelector('template')?.content?.querySelector('.js-youtube')
      )
        activeMedia.loadContent();
    }
  }

  customElements.define('product-modal', ProductModal);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  class ProductModal extends ModalDialog {
    constructor() {
      super();
    }

    hide() {
      super.hide();
      window.pauseAllMedia();
    }

    show(opener) {
      super.show(opener);
      this.showActiveMedia();
    }

    showActiveMedia() {
      this.querySelectorAll(
        `[data-media-id]:not([data-media-id="${this.openedBy.getAttribute('data-media-id')}"])`
      ).forEach((element) => {
        element.classList.remove('active');
      });
      const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);
      activeMedia.classList.add('active');
      activeMedia.scrollIntoView();

      const container = this.querySelector('[role="document"]');
      container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

      if (
        activeMedia.nodeName == 'DEFERRED-MEDIA' &&
        activeMedia.querySelector('template')?.content?.querySelector('.js-youtube')
      )
        activeMedia.loadContent();
    }
  }

  customElements.define('product-modal', ProductModal);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mini-cart"]) return;
  try {
    
  class CartNote extends HTMLElement {
    constructor() {
      super();

	  const noteBoxContainer = document.getElementById('cart__note');
    const noteBox = document.getElementById('Cart-note');
	  const bodytest = fetch(`${routes.cart_url}`);
      this.addEventListener('input', debounce((event) => {
        const body = JSON.stringify({ note: event.target.value });
        fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }});
      }))
    }
  }

  customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["trust-strip"] && !Shopify.designMode) return;
  try {
    
/* Trust strip: overflow detection and keyboard scrolling.
   Served as a static asset, so Liquid is never evaluated here. */
(function () {
  function init(container) {
    if (container.dataset.trustStripReady === 'true') return;
    container.dataset.trustStripReady = 'true';

    var viewport = container.querySelector('.trust-strip__viewport');
    var track = viewport && viewport.querySelector('.trust-strip__track');
    if (!viewport || !track) return;

    var isSwipe = container.classList.contains('is-swipe');
    var isTicker = container.classList.contains('is-ticker');
    var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    var cleanup = [];

    function listen(target, type, handler, options) {
      if (!target) return;
      target.addEventListener(type, handler, options);
      cleanup.push(function () { target.removeEventListener(type, handler, options); });
    }

    function isManualScrollMode() {
      return isSwipe || (isTicker && reducedMotion.matches);
    }

    function updateOverflow() {
      var hasOverflow = track.scrollWidth - viewport.clientWidth > 1;
      container.classList.toggle('has-overflow', hasOverflow);
      if (hasOverflow && isManualScrollMode()) {
        viewport.setAttribute('tabindex', '0');
      } else {
        viewport.removeAttribute('tabindex');
      }
    }

    function snapPoints() {
      return Array.prototype.slice.call(track.children)
        .filter(function (el) { return !el.classList.contains('trust-strip__item--clone'); })
        .map(function (el) { return el.offsetLeft; });
    }

    function nearestIndex(points, x) {
      var idx = 0;
      var best = Infinity;
      for (var i = 0; i < points.length; i++) {
        var distance = Math.abs(points[i] - x);
        if (distance < best) {
          best = distance;
          idx = i;
        }
      }
      return idx;
    }

    function scrollToIndex(target) {
      var points = snapPoints();
      if (!points.length) return;
      var idx = Math.max(0, Math.min(target, points.length - 1));
      viewport.scrollTo({
        left: points[idx],
        behavior: reducedMotion.matches ? 'auto' : 'smooth'
      });
      if (isSwipe) setTimeout(updateStatus, 200);
    }

    function onViewportKeydown(event) {
      if (!isManualScrollMode() || !container.classList.contains('has-overflow')) return;
      if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
      event.preventDefault();
      var direction = event.key === 'ArrowRight' ? 1 : -1;
      scrollToIndex(nearestIndex(snapPoints(), viewport.scrollLeft) + direction);
    }

    function onResize() {
      updateOverflow();
      if (isSwipe) updateStatus();
    }

    function onMotionChange() {
      updateOverflow();
    }

    listen(window, 'resize', onResize);
    listen(reducedMotion, 'change', onMotionChange);
    listen(viewport, 'keydown', onViewportKeydown);

    container.tsTeardown = function () {
      cleanup.forEach(function (removeListener) { removeListener(); });
      container.dataset.trustStripReady = 'false';
    };

    Array.prototype.forEach.call(track.querySelectorAll('img'), function (img) {
      if (!img.complete) img.addEventListener('load', updateOverflow, { once: true });
    });

    updateOverflow();

    if (!isSwipe) return;

    var prevBtn = container.querySelector('.trust-strip__prev');
    var nextBtn = container.querySelector('.trust-strip__next');
    var statusEl = container.querySelector('.trust-strip__status');

    function updateStatus() {
      if (statusEl) {
        var points = snapPoints();
        statusEl.textContent = points.length
          ? 'Item ' + (nearestIndex(points, viewport.scrollLeft) + 1) + ' of ' + points.length
          : '';
      }
      updateControls();
    }

    function setSpent(button, spent) {
      if (!button) return;
      button.setAttribute('aria-disabled', spent ? 'true' : 'false');
    }

    function updateControls() {
      var maxScroll = track.scrollWidth - viewport.clientWidth;
      setSpent(prevBtn, viewport.scrollLeft <= 1);
      setSpent(nextBtn, viewport.scrollLeft >= maxScroll - 1);
    }

    function onPrevious() {
      if (prevBtn.getAttribute('aria-disabled') === 'true') return;
      scrollToIndex(nearestIndex(snapPoints(), viewport.scrollLeft) - 1);
    }

    function onNext() {
      if (nextBtn.getAttribute('aria-disabled') === 'true') return;
      scrollToIndex(nearestIndex(snapPoints(), viewport.scrollLeft) + 1);
    }

    function onScroll() {
      if (viewport.tsScrolling) return;
      viewport.tsScrolling = true;
      window.requestAnimationFrame(function () {
        updateStatus();
        viewport.tsScrolling = false;
      });
    }

    listen(prevBtn, 'click', onPrevious);
    listen(nextBtn, 'click', onNext);
    listen(viewport, 'scroll', onScroll);
    updateStatus();
  }

  function initAll(scope) {
    Array.prototype.forEach.call((scope || document).querySelectorAll('.trust-strip'), init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }

  function teardownAll(scope) {
    Array.prototype.forEach.call((scope || document).querySelectorAll('.trust-strip'), function (el) {
      if (typeof el.tsTeardown === 'function') el.tsTeardown();
    });
  }

  /* Tear down before re-init, and on removal. */
  document.addEventListener('shopify:section:unload', function (event) { teardownAll(event.target); });
  document.addEventListener('shopify:section:load', function (event) {
    teardownAll(event.target);
    initAll(event.target);
  });
})();

  } catch(e) { console.error(e); }
})();
})();
